

export const colors = {
  white: '#ffffff',
  snow: '#f6f6f6',
  lightWhite: '#efefef',
  darkWhite: '#d2d2d2',
  black: '#202224',
  lightBlack: '#4a4d51',
  gray: '#555555',
  lightGray: '#b3b3b3',
  red: '#ef2828',
  purple: '#9123e3',
  blue: '#2196f3',
  green: '#00c250',
  translucent: 'rgba(0, 0, 0, 0.6)',
  transparent: 'transparent',
}

export const fileBaseUrl = 'https://file.deeppp.com/'
